import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import {
  MyAddressAllResponse,
  AddressPayload,
} from '../../../../../core/models/user.model';
import {
  TaxpayerInfo,
  StatusAPIResponse,
} from '../../../../../core/models/information.model';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiMemberService } from '../../../../../core/services/api/Member/api-member';
@Component({
  selector: 'app-address',
  imports: [
    CommonModule,
    FormsModule,
    PssLoadingComponent
  ],
  templateUrl: './address.component.html',
  styleUrl: './address.component.css',
})
export class AddressComponent implements OnInit {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;
  token: string = '';
  uid: string = '';
  selectedTaxType: string = '1';
  isLoading: boolean = false;
  tambons: any[] = [];
  amphures: any[] = [];
  provincess: any[] = [];
  address_id: number = 0;
  addressListAll: MyAddressAllResponse[] = [];
  selectedAddress: MyAddressAllResponse | null = null;
  showSelectAddress: boolean = false;
  filteredAddressList: MyAddressAllResponse[] = [];
  mainOffice: boolean = false;
  taxName: string = '';
  taxId: string = '';
  address: string = '';
  province_name: string | null = null;
  amphure_name: string | null = null;
  tambon_name: string | null = null;
  email: string = '';
  tax_phone: string = '';
  branchName: string = '';
  branchNo: string = '';
  selectedTambonId: number | null = null;
  selectedProvinceId: number | null = null;
  selectedAmphureId: number | null = null;
  filteredAmphures: any[] = [];
  filteredTambons: any[] = [];
  zipcode: string = '';
  showAddressModal: boolean = false;

  provinceSearchText: string = '';
  amphureSearchText: string = '';
  tambonSearchText: string = '';
  activeDropdown: 'province' | 'amphure' | 'tambon' | null = null;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''


  searchQuery: string = '';

  constructor(
    private cookieService: CookieService,
    private apiMemberService: ApiMemberService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private http: HttpClient,
    private languageService: LanguageService,
    private location: Location
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    setTimeout(() => {
      this.getApiAddressAll();
      this.http
        .get<any[]>('json/thai_tambons.json')
        .subscribe((data) => (this.tambons = data));
      this.http
        .get<any[]>('json/thai_amphures.json')
        .subscribe((data) => (this.amphures = data));
      this.http
        .get<any[]>('json/thai_provinces.json')
        .subscribe((data) => (this.provincess = data));
    }, 400);
  }

  /* --------------------------------------- Function --------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }
  /* --- Function --- */
  getApiAddressAll() {
    this.isLoading = true;
    this.address_id = 0;
    this.apiMemberService.getMyAddress(this.token, this.uid).subscribe({
      next: (response: MyAddressAllResponse[]) => {
        this.isLoading = false;
        console.log(response);
        this.addressListAll = response;
        this.selectedAddress = null;
        if (this.addressListAll.length > 0) {
          this.showSelectAddress = true;

          const type = 1; // แปลงเป็น number
          this.filteredAddressList = this.addressListAll.filter(
            (item) => item.address_user_type === type
          );
          // this.selectedAddress = this.filteredAddressList[0];
          // this.setValueAddress();
        } else {
          this.showSelectAddress = false;
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('API error:', error);
      },
    });
  }

  filterAddressByTaxType(): void {
    this.filteredAddressList = [];
    this.selectedAddress = null;
    this.address_id = 0;
    const type = parseInt(this.selectedTaxType, 10); // แปลงเป็น number
    this.filteredAddressList = this.addressListAll.filter(
      (item) => item.address_user_type === type
    );
    if (this.filteredAddressList.length > 0) {
      this.showSelectAddress = true;
      this.selectedAddress = this.filteredAddressList[0];
    } else {
      this.showSelectAddress = false;
      this.selectedAddress = null;
    }
  }

  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/profile']);
    }
  }

  changeTaxType(type: string) {
    this.selectedTaxType = type;
    this.filterAddressByTaxType();
    this.onSearchQueryChange();
  }

  onSearchQueryChange() {
    const query = this.searchQuery.trim().toLowerCase();
    const type = parseInt(this.selectedTaxType, 10);
    let list = this.addressListAll.filter(item => item.address_user_type === type);
    if (query) {
      list = list.filter(item => 
        (item.full_name && item.full_name.toLowerCase().includes(query)) ||
        (item.company_name && item.company_name.toLowerCase().includes(query)) ||
        (item.address && item.address.toLowerCase().includes(query))
      );
    }
    this.filteredAddressList = list;
  }

  onNumberInput(field: string, event: any) {
    const val = event.target.value.replace(/[^0-9]/g, '');
    if (field === 'taxId') {
      this.taxId = val;
    } else if (field === 'tax_phone') {
      this.tax_phone = val;
    }
    event.target.value = val;
  }

  get filteredProvincess() {
    const text = this.provinceSearchText.trim().toLowerCase();
    if (!text) return this.provincess;
    return this.provincess.filter(p => p.name_th.toLowerCase().includes(text));
  }

  get filteredAmphureOptions() {
    const text = this.amphureSearchText.trim().toLowerCase();
    if (!text) return this.filteredAmphures;
    return this.filteredAmphures.filter(a => a.name_th.toLowerCase().includes(text));
  }

  get filteredTambonOptions() {
    const text = this.tambonSearchText.trim().toLowerCase();
    if (!text) return this.filteredTambons;
    return this.filteredTambons.filter(t => t.name_th.toLowerCase().includes(text));
  }

  openDropdown(type: 'province' | 'amphure' | 'tambon') {
    this.activeDropdown = type;
  }

  closeDropdown(type: 'province' | 'amphure' | 'tambon') {
    setTimeout(() => {
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      }
      this.validateAndRevertText(type);
    }, 200);
  }

  validateAndRevertText(type: 'province' | 'amphure' | 'tambon') {
    if (type === 'province') {
      const match = this.provincess.find(p => p.name_th === this.provinceSearchText);
      if (match) {
        this.selectedProvinceId = match.id;
        this.province_name = match.name_th;
      } else {
        this.provinceSearchText = this.province_name || '';
      }
    } else if (type === 'amphure') {
      const match = this.filteredAmphures.find(a => a.name_th === this.amphureSearchText);
      if (match) {
        this.selectedAmphureId = match.id;
        this.amphure_name = match.name_th;
      } else {
        this.amphureSearchText = this.amphure_name || '';
      }
    } else if (type === 'tambon') {
      const match = this.filteredTambons.find(t => t.name_th === this.tambonSearchText);
      if (match) {
        this.selectedTambonId = match.id;
        this.tambon_name = match.name_th;
      } else {
        this.tambonSearchText = this.tambon_name || '';
      }
    }
  }

  selectProvinceOption(province: any) {
    this.selectedProvinceId = province.id;
    this.province_name = province.name_th;
    this.provinceSearchText = province.name_th;
    this.activeDropdown = null;
    this.onProvinceChange();
    this.amphureSearchText = '';
    this.tambonSearchText = '';
  }

  selectAmphureOption(amphure: any) {
    this.selectedAmphureId = amphure.id;
    this.amphure_name = amphure.name_th;
    this.amphureSearchText = amphure.name_th;
    this.activeDropdown = null;
    this.onAmphureChange();
    this.tambonSearchText = '';
  }

  selectTambonOption(tambon: any) {
    this.selectedTambonId = tambon.id;
    this.tambon_name = tambon.name_th;
    this.tambonSearchText = tambon.name_th;
    this.activeDropdown = null;
    this.onTambonsChange();
  }

  setValueAddress() {
    if (this.selectedAddress) {
      this.address_id = this.selectedAddress.id;
      this.mainOffice = this.selectedAddress.headquarters;
      this.taxName = this.selectedAddress.name;
      this.tax_phone = this.selectedAddress.phone;
      this.email = this.selectedAddress.email;
      this.branchName = this.selectedAddress.branch;
      this.branchNo = this.selectedAddress.branch_no;
      this.taxId = this.selectedAddress.tax_id;
      this.address = this.selectedAddress.address;
      this.tax_phone = this.selectedAddress.phone;

      const selectedProvName = this.selectedAddress?.provinces?.trim() ?? '';
      const matchedProvince = this.provincess.find(
        (p) => p.name_th.trim() === selectedProvName
      );
      if (matchedProvince) {
        this.selectedProvinceId = matchedProvince.id;
        this.province_name = selectedProvName;
        this.provinceSearchText = selectedProvName;
      } else {
        this.selectedProvinceId = null;
        this.province_name = '';
        this.provinceSearchText = '';
      }

      if (this.selectedProvinceId != null) {
        const provinceId = this.selectedProvinceId;
        this.filteredAmphures = this.amphures.filter(
          (a) => a.province_id === +provinceId
        );

        const selectedAmphureName =
          this.selectedAddress?.district?.trim() ?? '';
        const matchedAmphure = this.filteredAmphures.find(
          (a) => a.name_th.trim() === selectedAmphureName
        );
        if (matchedAmphure) {
          this.selectedAmphureId = matchedAmphure.id;
          this.amphure_name = selectedAmphureName;
          this.amphureSearchText = selectedAmphureName;
        } else {
          this.selectedAmphureId = null;
          this.amphure_name = '';
          this.amphureSearchText = '';
        }
      } else {
        this.filteredAmphures = [];
        this.selectedAmphureId = null;
        this.amphure_name = '';
        this.amphureSearchText = '';
      }

      if (this.selectedAmphureId != null) {
        const amphureId = this.selectedAmphureId;

        // กรองตำบลในอำเภอที่เลือก
        this.filteredTambons = this.tambons.filter(
          (a) => a.amphure_id === +amphureId
        );

        // ดึงชื่อจากที่อยู่
        const selectedTambonName =
          this.selectedAddress?.sub_district?.trim() ?? '';

        // หาใน list ว่าตรงกับตำบลไหน
        const matchedTambon = this.filteredTambons.find(
          (a) => a.name_th.trim() === selectedTambonName
        );

        if (matchedTambon) {
          this.selectedTambonId = matchedTambon.id;
          this.tambon_name = selectedTambonName;
          this.tambonSearchText = selectedTambonName;
          this.zipcode = this.selectedAddress.zip_code;
        } else {
          this.selectedTambonId = null;
          this.tambon_name = '';
          this.tambonSearchText = '';
          this.zipcode = '';
        }
      } else {
        this.filteredTambons = [];
        this.selectedTambonId = null;
        this.tambon_name = '';
        this.tambonSearchText = '';
      }
    } else {
      // ✅ ล้างค่าเมื่อไม่มี selectedAddress
      this.clear();
    }
  }

  clear() {
    this.address_id = 0;
    this.mainOffice = false;
    this.taxName = '';
    this.tax_phone = '';
    this.email = '';
    this.branchName = '';
    this.branchNo = '';
    this.taxId = '';
    this.address = '';
    this.zipcode = '';
    this.selectedProvinceId = null;
    this.province_name = '';
    this.filteredAmphures = [];

    this.selectedAmphureId = null;
    this.amphure_name = '';
    this.filteredTambons = [];

    this.provinceSearchText = '';
    this.amphureSearchText = '';
    this.tambonSearchText = '';
    this.activeDropdown = null;
  }

  selectAddress(address: MyAddressAllResponse) {
    console.log('select address', address);
    this.selectedAddress = address;
    this.setValueAddress();
    this.showAddressModal = true;
  }

  openAddressModal() {
    this.selectedAddress = null;
    this.clear();
    this.showAddressModal = true;
  }
  closeTaxModal() {
    this.showAddressModal = false;
  }

  ApigetAddressByTaxId() {
    this.apiMemberService.getAddressByTaxId(this.taxId.trim()).subscribe({
      next: (response: TaxpayerInfo) => {
        this.isLoading = false;
        //  console.log(JSON.stringify(response).toString());
        if (!response || Object.keys(response).length === 0) {
          this.showError(
            this.currentLang === 'TH' ? 'ไม่พบข้อมูล' : 'Not found'
          );
          return;
        } else {
          this.taxName =
            response.company_branch_title_name + ' ' + response.company_name;
          this.address =
            response.company_address_no +
            ' หมู่ที่ ' +
            response.company_moo_number;
          if (response.company_branch_number === '0') {
            this.mainOffice = true;
          } else {
            this.mainOffice = false;
            this.branchName = response.company_branch_name;
          }
          const matchedProvince = this.provincess.find(
            (p) => p.name_th.trim() === response.company_province
          );
          if (matchedProvince) {
            this.selectedProvinceId = matchedProvince.id;
            this.province_name = response.company_province;
            this.provinceSearchText = response.company_province;
          } else {
            this.selectedProvinceId = null;
            this.province_name = '';
            this.provinceSearchText = '';
          }
          if (this.selectedProvinceId != null) {
            const provinceId = this.selectedProvinceId;
            this.filteredAmphures = this.amphures.filter(
              (a) => a.province_id === +provinceId
            );

            const selectedAmphureName = response.company_amphur;
            const matchedAmphure = this.filteredAmphures.find(
              (a) => a.name_th.trim() === selectedAmphureName
            );
            if (matchedAmphure) {
              this.selectedAmphureId = matchedAmphure.id;
              this.amphure_name = selectedAmphureName;
              this.amphureSearchText = selectedAmphureName;
            } else {
              this.selectedAmphureId = null;
              this.amphure_name = '';
              this.amphureSearchText = '';
            }
          } else {
            this.filteredAmphures = [];
            this.selectedAmphureId = null;
            this.amphure_name = '';
            this.amphureSearchText = '';
          }
          if (this.selectedAmphureId != null) {
            const amphureId = this.selectedAmphureId;

            // กรองตำบลในอำเภอที่เลือก
            this.filteredTambons = this.tambons.filter(
              (a) => a.amphure_id === +amphureId
            );

            // ดึงชื่อจากที่อยู่
            const selectedTambonName = response.company_thambol;

            // หาใน list ว่าตรงกับตำบลไหน
            const matchedTambon = this.filteredTambons.find(
              (a) => a.name_th.trim() === selectedTambonName
            );

            if (matchedTambon) {
              this.selectedTambonId = matchedTambon.id;
              this.tambon_name = selectedTambonName;
              this.tambonSearchText = selectedTambonName;
              this.zipcode = response.company_postcode;
            } else {
              this.selectedTambonId = null;
              this.tambon_name = '';
              this.tambonSearchText = '';
              this.zipcode = '';
            }
          } else {
            this.filteredTambons = [];
            this.selectedTambonId = null;
            this.tambon_name = '';
            this.tambonSearchText = '';
          }
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  getAddressByTaxId() {
    if (!this.taxId.trim()) {
      this.showWarning('กรุณาระบุเลขผู้เสียภาษีก่อน');
    } else {
      this.isLoading = true;
      this.ApigetAddressByTaxId();
    }
  }
  onProvinceChange() {
    // console.log(this.selectedProvinceId);
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.amphure_name = '';
    this.tambon_name = '';
    this.filteredAmphures =
      (this.selectedProvinceId ?? null) !== null
        ? this.amphures.filter(
          (a) => a.province_id === +this.selectedProvinceId!
        )
        : [];
    if (this.provincess.length && this.selectedProvinceId) {
      const province = this.provincess.find(
        (a) => a.id === Number(this.selectedProvinceId)
      );
      this.province_name = province ? province.name_th : '';
      // console.log('✅ province_name:', this.province_name);
    } else {
      console.warn('⚠️ province list or selectedProvinceId not ready');
    }

    this.filteredTambons = []; // reset
  }

  onAmphureChange() {
    this.selectedTambonId = null;
    this.zipcode = '';
    this.tambon_name = '';
    this.filteredTambons =
      (this.selectedAmphureId ?? null) !== null
        ? this.tambons.filter((a) => a.amphure_id === +this.selectedAmphureId!)
        : [];
    if (this.amphures.length && this.selectedAmphureId) {
      const amphure = this.amphures.find(
        (a) => a.id === Number(this.selectedAmphureId)
      );
      this.amphure_name = amphure ? amphure.name_th : '';
      // console.log('✅ amphure_name:', this.amphure_name);
    }
  }

  onTambonsChange() {
    // console.log(this.selectedTambonId);
    this.zipcode = '';
    this.zipcode =
      (this.selectedTambonId ?? null) !== null
        ? this.tambons.filter((t) => t.id === +this.selectedTambonId!)[0]
          ?.zip_code || ''
        : '';

    if (this.tambons.length && this.selectedTambonId) {
      const tambon = this.tambons.find(
        (a) => a.id === Number(this.selectedTambonId)
      );
      this.tambon_name = tambon ? tambon.name_th : '';
      // console.log(this.tambon_name);
    }
  }

  submitAddress() {
    if (!this.taxName.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุชื่อผู้เสียภาษี'
          : 'Please specify your Taxpayer name .'
      );
    } else if (
      !this.branchName.trim() &&
      !this.branchNo.trim() &&
      !this.mainOffice &&
      this.selectedTaxType === '2'
    ) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุสาขาและรหัสสาขา'
          : 'Please specify your Branch and branch code .'
      );
    } else if (!this.tax_phone.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุเบอร์โทรศัพท์'
          : 'Please specify your phone number.'
      );
    } else if (!this.taxId.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุเลขประจำตัวผู้เสียภาษี'
          : 'Please specify your TAX ID .'
      );
    } else if (!this.address.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุที่อยู่'
          : 'Please specify your address .'
      );
    } else if (this.selectedProvinceId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุจังหวัด'
          : 'Please specify your province .'
      );
    } else if (this.selectedAmphureId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุอำเภอ'
          : 'Please specify your Amphure .'
      );
    } else if (this.selectedTambonId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุตำบล'
          : 'Please specify your Tambon .'
      );
    } else if (!this.zipcode) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุรหัสไปรษณีย์'
          : 'Please specify your Postal code .'
      );
    } else {
      this.showAddressModal = false;
      this.saveAddressApi();
    }
  }

  saveAddressApi() {
    const payload: AddressPayload = {
      uid: this.uid,
      address_id: this.address_id,
      full_name: this.taxName,
      address_user_type: parseInt(this.selectedTaxType || '0', 10),
      address: this.address || '',
      sub_district: this.tambon_name || '',
      district: this.amphure_name || '',
      provinces: this.province_name || '',
      zip_code: this.zipcode || '',
      email: this.email || '',
      branch: this.branchName || '',
      branch_no: this.branchNo || '',
      headquarters: this.mainOffice,
      taxId: this.taxId,
      phone_tax: this.tax_phone,
    };
    if (payload) {
      this.isLoading = true;
      console.log(payload);
      this.apiMemberService.UpdateAddress(payload, this.token).subscribe({
        next: (res: StatusAPIResponse) => {
          this.isLoading = false;
          this.getApiAddressAll();
          this.clear();
          this.showSuccess(
            this.currentLang === 'TH' ? 'บันทึกสำเร็จ' : 'Saved successfully.'
          );
        },
        error: (err) => {
          this.isLoading = false;
          console.error('❌  ไม่สำเร็จ:', err);
          this.showError(
            this.currentLang === 'TH'
              ? 'บันทึกไม่สำเร็จ'
              : 'Save not successful.'
          );
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    } else {
      console.log('No Payload');
    }
  }
}
